export { default } from './LineupCamBadge';
